"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerWrapper = exports.Flex = exports.Heading = exports.Wrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _functions = require("@berlitz/globals/lib/functions");
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Alertstyle__Wrapper",
  componentId: "sc-16syxbq-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme,
    type = _ref.type,
    rounded = _ref.rounded;
  var paletteKey = type === 'error' ? 'danger' : type;
  return (0, _styledComponents.css)(["background-color:", ";padding:", ";display:inline-flex;width:100%;", ";"], theme.palette["".concat(paletteKey, "10")], function (_ref2) {
    var theme = _ref2.theme;
    return theme.space.sm;
  }, rounded && (0, _styledComponents.css)(["border-radius:", ";border:1px solid ", ";"], theme.input.borderRadius, theme.palette["".concat(paletteKey, "20")]));
});
exports.Wrapper = Wrapper;
var Heading = _styledComponents.default.span.withConfig({
  displayName: "Alertstyle__Heading",
  componentId: "sc-16syxbq-1"
})(["font-weight:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeight.bold;
});
exports.Heading = Heading;
var Flex = _styledComponents.default.span.withConfig({
  displayName: "Alertstyle__Flex",
  componentId: "sc-16syxbq-2"
})(["display:flex;width:100%;@media (max-width:", "){display:initial;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm;
});
exports.Flex = Flex;
var InnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "Alertstyle__InnerWrapper",
  componentId: "sc-16syxbq-3"
})(["width:100%;font-size:", ";line-height:1.6;", ";p{font-size:", ";margin-bottom:", ";}@media (min-width:", "){justify-content:space-between;display:flex;align-items:center;}@media (min-width:", "){display:flex;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSize.xxxs;
}, function (_ref6) {
  var theme = _ref6.theme;
  return (0, _styledComponents.css)(["h1{", " margin-bottom:", ";}h2{", " margin-bottom:", ";}"], (0, _functions.getFontStyle)(theme.typography.h3, theme.breakpoints.sm), theme.space.xxs, (0, _functions.getFontStyle)(theme.typography.h3, theme.breakpoints.sm), theme.space.xxs);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.xxxs;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.xxxs;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.sm;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.breakpoints.md;
});
exports.InnerWrapper = InnerWrapper;